import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaSort, FaEye } from 'react-icons/fa';
import ComponenteActualizarExistencias from '../ActualizarExistencias'; // Ajustar ruta según ubicación
import ConteoCheck from '../productos/ConteoCheck'; // Ajustar ruta
import { getStatusClasses, getPriorityClasses } from '../../utils/LabelColors'; // Ajustar ruta
import formatCurrency from '../../utils/formatCurrency'; // Ajustar ruta
import Cookies from 'js-cookie';

const TablaVariantes = ({
    productosHijos,
    setProductosHijos,
    token,
    isMobile = false
}) => {
    const navigate = useNavigate();
    const idEmpleado = Cookies.get('id_empleado');

    if (!productosHijos || productosHijos.length === 0) {
        return <div className="p-4 text-center text-gray-500">No hay variantes asociadas.</div>;
    }

    // Versión Mobile (Simple list/card)
    if (isMobile) {
        return (
            <div className="space-y-4">
                {productosHijos.map((prodHijo) => (
                    <div key={prodHijo.id_producto} className="bg-white border rounded-lg p-4 shadow-sm">
                        <div className="flex justify-between items-start mb-2">
                            <div>
                                <h4 className="font-bold text-gray-800">{prodHijo.nombre_producto}</h4>
                                <span className="text-xs text-blue-600 bg-blue-50 px-2 py-0.5 rounded-full font-semibold">
                                    {prodHijo.marca_hijo || 'Variante'}
                                </span>
                            </div>
                            <div className={`px-2 py-1 text-xs rounded font-bold ${getStatusClasses(prodHijo.estado)}`}>
                                {prodHijo.estado}
                            </div>
                        </div>

                        <div className="text-sm text-gray-600 space-y-1">
                            <p><strong>SKU:</strong> {prodHijo.sku}</p>
                            <div className="flex justify-between">
                                <span><strong>P. Venta:</strong> {formatCurrency(prodHijo.precio_venta)}</span>
                                <ComponenteActualizarExistencias
                                    producto={prodHijo}
                                    idEmpleado={idEmpleado}
                                    token={token}
                                    onSuccess={({ nuevaCantidad }) => {
                                        setProductosHijos((prev) =>
                                            prev.map((p) =>
                                                p.id_producto === prodHijo.id_producto
                                                    ? { ...p, existencias: nuevaCantidad }
                                                    : p
                                            )
                                        );
                                    }}
                                />
                            </div>
                        </div>

                        <div className="mt-3 flex justify-end space-x-2">
                            <button
                                onClick={() => navigate(`/productos/vista/${prodHijo.id_producto}`)}
                                className="text-green-500 hover:text-green-700 p-2"
                                title="Ver Vista Producto"
                            >
                                <FaEye size={18} />
                            </button>
                            <button
                                onClick={() => navigate(`/productos/editar/${prodHijo.id_producto}`)}
                                className="text-blue-500 hover:text-blue-700 p-2"
                                title="Editar Variante"
                            >
                                <FaEdit size={18} />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    // Versión Desktop (Tabla completa)
    return (
        <div className="overflow-x-auto rounded-lg shadow-sm border border-gray-200">
            <table className="min-w-full divide-y divide-gray-200 text-sm">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">SKU / Barras</th>
                        <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">Variante / Atributo</th>
                        <th className="px-4 py-3 text-center font-medium text-gray-500 uppercase tracking-wider">Auditoría</th>
                        <th className="px-4 py-3 text-right font-medium text-gray-500 uppercase tracking-wider">Precio</th>
                        <th className="px-4 py-3 text-center font-medium text-gray-500 uppercase tracking-wider">Existencias</th>
                        <th className="px-4 py-3 text-center font-medium text-gray-500 uppercase tracking-wider">Estado</th>
                        <th className="px-4 py-3 text-center font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {productosHijos.map((hijo) => (
                        <tr key={hijo.id_producto} className="hover:bg-gray-50 transition-colors">
                            <td className="px-4 py-3">
                                <div className="font-bold text-gray-800">{hijo.sku}</div>
                                <div className="text-xs text-gray-500 font-mono">{hijo.codigo_barras}</div>
                            </td>
                            <td className="px-4 py-3">
                                <div className="font-medium text-gray-700">{hijo.nombre_producto}</div>
                                <span className="inline-block mt-1 px-2 py-0.5 rounded text-xs font-bold bg-blue-100 text-blue-700">
                                    {hijo.marca_hijo || 'Variante'}
                                    {/* Aquí podríamos mostrar "Color: Rojo" si tuviéramos esa data estructurada */}
                                </span>
                            </td>
                            <td className="px-4 py-3 flex justify-center">
                                <ConteoCheck
                                    show={hijo.tieneMovimientosRecientes}
                                    empleado={hijo.nombre_empleado}
                                    fecha={hijo.fecha_ultimo_movimiento}
                                />
                            </td>
                            <td className="px-4 py-3 text-right font-medium text-gray-800">
                                {formatCurrency(hijo.precio_venta)}
                            </td>
                            <td className="px-4 py-3 text-center">
                                <div className="flex justify-center">
                                    <ComponenteActualizarExistencias
                                        producto={hijo}
                                        idEmpleado={idEmpleado}
                                        token={token}
                                        onSuccess={({ nuevaCantidad }) => {
                                            setProductosHijos((prev) =>
                                                prev.map((p) =>
                                                    p.id_producto === hijo.id_producto
                                                        ? { ...p, existencias: nuevaCantidad }
                                                        : p
                                                )
                                            );
                                        }}
                                    />
                                </div>
                            </td>
                            <td className="px-4 py-3 text-center">
                                <span className={`px-2 py-1 rounded text-xs font-bold ${getStatusClasses(hijo.estado)}`}>
                                    {hijo.estado}
                                </span>
                            </td>
                            <td className="px-4 py-3 text-center">
                                <button
                                    onClick={() => navigate(`/productos/vista/${hijo.id_producto}`)}
                                    className="text-gray-400 hover:text-green-600 transition-colors p-2 rounded-full hover:bg-green-50 mr-1"
                                    title="Ver Vista Producto"
                                >
                                    <FaEye size={16} />
                                </button>
                                <button
                                    onClick={() => navigate(`/productos/editar/${hijo.id_producto}`)}
                                    className="text-gray-400 hover:text-blue-600 transition-colors p-2 rounded-full hover:bg-blue-50"
                                    title="Editar Variante"
                                >
                                    <FaEdit size={16} />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TablaVariantes;
